module.exports = __webpack_public_path__ + "static/media/daily_calendar_disabled.4ee3b5bb.svg";